import mime from 'mime';

import { ApiFragment } from '../entities/api-fragment.entity';

/**
 * The format a single record exists in: the extension it declares, else a guess from its MIME type, else
 * nothing. An analog carrier has no extension at all and is named by the caller's label instead.
 *
 * `null` rather than the empty string the representaties overview used to print: the tree's Formaten badges
 * have to tell "no format known" apart from one that happens to be blank.
 *
 * Every block is read defensively: HFBD-75 points the `Formaten` column at flat rows of any type, and a search
 * row only carries the blocks its page asked for.
 */
export function toRecordFormat(fragment: ApiFragment, analogLabel: string): string | null {
    if (fragment.metadata.Dynamic?.Carrier === 'Analog') {
        return analogLabel;
    }

    if (fragment.metadata.Technical?.OriginalExtension) {
        return fragment.metadata.Technical.OriginalExtension;
    }

    // ED-4136: If the OriginalExtension is not available, try to get the extension from the MimeType
    if (fragment.metadata.Technical?.MimeType) {
        console.warn(
            'toRecordFormat:: No OriginalExtension data found. Making guess based on MimeType ',
            fragment.metadata.Technical.MimeType,
            mime.getExtension(fragment.metadata.Technical.MimeType)
        );

        return mime.getExtension(fragment.metadata.Technical.MimeType);
    }

    // Deliberately silent, unlike the branch above: most stukken carry no `Technical` block at all, so the
    // badges' batch of 125 representaties would flood the console with an outcome this returns anyway.
    return null;
}
